import type { SVGProps } from "react";
import * as React from "react";
const SvgOffice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="url(#Office_svg__a)"
      d="m10.22 2.465-.102.062a3.636 3.636 0 0 0-.458.328l.294-.207h2.5l.455 3.442-2.273 2.273-2.273 1.58v1.822c0 1.272.665 2.452 1.754 3.11l2.393 1.449-5.056 2.949H6.48l-1.817-1.1a3.637 3.637 0 0 1-1.753-3.111V8.936c0-1.273.665-2.453 1.754-3.112l5.455-3.299.102-.06Z"
    />
    <path
      fill="url(#Office_svg__b)"
      d="m10.22 2.465-.102.062a3.636 3.636 0 0 0-.458.328l.294-.207h2.5l.455 3.442-2.273 2.273-2.273 1.58v1.822c0 1.272.665 2.452 1.754 3.11l2.393 1.449-5.056 2.949H6.48l-1.817-1.1a3.637 3.637 0 0 1-1.753-3.111V8.936c0-1.273.665-2.453 1.754-3.112l5.455-3.299.102-.06Z"
    />
    <path
      fill="url(#Office_svg__c)"
      d="M15.636 9.727v2.036a3.637 3.637 0 0 1-1.753 3.111l-5.455 3.302a3.637 3.637 0 0 1-3.64.073l5.329 3.225c1.157.701 2.608.701 3.766 0l5.455-3.301a3.637 3.637 0 0 0 1.753-3.111V13.59l-.454-.682-5-3.182Z"
    />
    <path
      fill="url(#Office_svg__d)"
      d="M15.636 9.727v2.036a3.637 3.637 0 0 1-1.753 3.111l-5.455 3.302a3.637 3.637 0 0 1-3.64.073l5.329 3.225c1.157.701 2.608.701 3.766 0l5.455-3.301a3.637 3.637 0 0 0 1.753-3.111V13.59l-.454-.682-5-3.182Z"
    />
    <path
      fill="url(#Office_svg__e)"
      d="m19.337 5.824-5.455-3.3a3.637 3.637 0 0 0-3.656-.062l-.108.065A3.636 3.636 0 0 0 8.363 5.64V9.95l1.755-1.061c1.157-.7 2.607-.7 3.764 0l5.455 3.3a3.637 3.637 0 0 1 1.752 2.992c.002-.04.002-.08.002-.12V8.937a3.637 3.637 0 0 0-1.754-3.112Z"
    />
    <path
      fill="url(#Office_svg__f)"
      d="m19.337 5.824-5.455-3.3a3.637 3.637 0 0 0-3.656-.062l-.108.065A3.636 3.636 0 0 0 8.363 5.64V9.95l1.755-1.061c1.157-.7 2.607-.7 3.764 0l5.455 3.3a3.637 3.637 0 0 1 1.752 2.992c.002-.04.002-.08.002-.12V8.937a3.637 3.637 0 0 0-1.754-3.112Z"
    />
    <defs>
      <radialGradient
        id="Office_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-5.3185 14.20382 -24.77429 -9.27653 9.008 5.926)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.064} stopColor="#AE7FE2" />
        <stop offset={1} stopColor="#0078D4" />
      </radialGradient>
      <radialGradient
        id="Office_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-8.367 123.316 -31.055) scale(14.1144 9.32348)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.134} stopColor="#D59DFF" />
        <stop offset={1} stopColor="#5E438F" />
      </radialGradient>
      <radialGradient
        id="Office_svg__e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-165.772 10.696 5.336) scale(11.329 19.0713)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.058} stopColor="#50E6FF" />
        <stop offset={1} stopColor="#436DCD" />
      </radialGradient>
      <linearGradient
        id="Office_svg__b"
        x1={9.051}
        x2={6.887}
        y1={18.304}
        y2={14.561}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#114A8B" />
        <stop offset={1} stopColor="#0078D4" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Office_svg__d"
        x1={19.435}
        x2={17.116}
        y1={12.625}
        y2={15.95}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#493474" />
        <stop offset={1} stopColor="#8C66BA" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Office_svg__f"
        x1={8.807}
        x2={12.221}
        y1={2.479}
        y2={2.479}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D3F80" />
        <stop offset={1} stopColor="#436DCD" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgOffice;
